<div id="devicePermissionsDialogCard" class="control-card-white">

  <div class="control-card-header">
    <ng-container i18n="@@devicePermissions_dialog">Permessi dispositivo</ng-container> {{permissions?.serial}}
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div id="content" class="control-card-content">


    <div id="datesDiv" class="date-wrapper">

      <div id="fromDateDiv" class="date-container">
        <p class="text-small text-dark" i18n="@@devicePermissions_start_date">
          Data di inizio:
        </p>
        <input id="from-datepicker-input" [readonly]=true [matDatepicker]="fromDatepicker"
          value="{{ permissions?.startDate }}" [formControl]="fromFormControl">
        <mat-datepicker-toggle matSuffix [for]="fromDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatepicker></mat-datepicker>
      </div>

      <div id="toDateDiv" class="date-container">
        <p class="text-small text-dark" i18n="@@devicePermissions__end_date">
          Data di fine:
        </p>
        <input id="to-datepicker-input" [readonly]=true [matDatepicker]="toDatepicker"
          value="{{ permissions?.expirationDate  }}" [formControl]="toFormControl">
        <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
        <mat-datepicker #toDatepicker></mat-datepicker>
      </div>

      <div id="useDefaultDiv" *ngIf="showUsePreviousButton">
        <a id="addTimeSlotButton" class="button-small button-grey margin-top-10" (click)="usePreviousPermissions()">
          <ng-container i18n="@@devicePermissions_dialog_apply_last_used">Applica ultimi inseriti</ng-container> <span>
            <fa-icon icon="redo"></fa-icon>
          </span>
        </a>
      </div>

    </div>

    <br>
    <div id="daysDiv">
      <p class="text-small text-dark" i18n="@@devicePermissions_validity_days">
        Giorni di validità:
      </p>

      <div class="weekdays">
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[0]" (change)="onDayChanged(1,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_monday">Lun</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[1]" (change)="onDayChanged(2,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_tuesday">Mar</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[2]" (change)="onDayChanged(3,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_wednesday">Mer</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[3]" (change)="onDayChanged(4,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_thursday">Gio</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[4]" (change)="onDayChanged(5,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_friday">Ven</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[5]" (change)="onDayChanged(6,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_saturday">Sab</span>
        </div>
        <div class="single-day">
          <label class="container-check">
            <input type="checkbox" [checked]="allDays[6]" (change)="onDayChanged(7,$event)" />
            <span class="checkmark clickable"></span>
          </label>
          <span i18n="@@day_short_sunday">Dom</span>
        </div>
      </div>
    </div>

    <br>

    <div id="hoursDiv">
      <div id="hoursTable">
        <p class="text-small text-dark" i18n="@@devicePermissions_dialog_validity_timetables">Orari apertura varco:</p>

        <table class="table-time-slot">
          <tbody>
            <tr *ngFor="let timeSlot of permissions?.timeSlots; let i = index">
              <td>
                <ng-container i18n="@@time_slot_from">Dalle</ng-container> {{ timeSlot?.getFromHourMin() }}
                <ng-container i18n="@@time_slot_to">alle</ng-container> {{ timeSlot?.getToHourMin() }}
              </td>
              <td>
                <fa-icon icon="trash" class="float-right margin-right-20 icon-clickable" (click)="deleteTimeSlot(i)">
                </fa-icon>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="" *ngIf="permissions?.timeSlots?.length == 0" i18n="@@devicePermissions_dialog_validity_all_day">
          Valida tutto il giorno
        </div>

        <a id="addTimeSlotButton" class="button-small button-grey margin-top-10" (click)="addTimeSlot()">
          <ng-container i18n="@@devicePermissions_dialog_add_time_slot">Aggiungi fascia oraria</ng-container> <span>
            <fa-icon icon="plus-circle"></fa-icon>
          </span>
          <br>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="control-card-buttons">
  <div>
    <a id="saveButton" (click)="saveShare()" class="button">
      <ng-container i18n="@@devicePermissions_dialog_save">Conferma</ng-container> <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>

    <a id="closeButton" (click)="closeDialog()" class="button">
      <ng-container i18n="@@devicePermissions_dialog_discard">Scarta modifiche</ng-container> <span>
        <fa-icon icon="trash"></fa-icon>
      </span>
    </a>

  </div>

  <ng-container *ngIf="error">
    <p class="text-small text-error margin-top-10 display-inline">
      {{ errorMessage }}
    </p>
  </ng-container>
</div>
